// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  home: {
    name: 'home',
    componentName: 'Home',
    chunk: () => import(
      /* webpackChunkName: "home" */
      './pages/Home'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Home.js')).Home
        : currentRouteName === 'home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/',
    channel: null
  },
  experience: {
    name: 'experience',
    componentName: 'Experience',
    chunk: () => import(
      /* webpackChunkName: "experience" */
      './pages/microApp/MicroApp'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/microApp/MicroApp.js')).MicroApp
        : currentRouteName === 'experience'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.MicroApp })));
    },
    path: '/:context?/:any?',
    channel: null
  },
  pip: {
    name: 'pip',
    componentName: 'Pip',
    chunk: () => import(
      /* webpackChunkName: "pip" */
      './pages/pip/Pip'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/pip/Pip.js')).Pip
        : currentRouteName === 'pip'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Pip })));
    },
    path: '/:context?/p/:slug?/:itemId',
    channel: null
  },
  pipEstimate: {
    name: 'pipEstimate',
    componentName: 'PipEstimate',
    chunk: () => import(
      /* webpackChunkName: "pipEstimate" */
      './pages/pip/PipEstimate'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/pip/PipEstimate.js')).PipEstimate
        : currentRouteName === 'pipEstimate'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PipEstimate })));
    },
    path: '/:context?/e/:slug?/:itemId',
    channel: null
  },
  pipMandi: {
    name: 'pipMandi',
    componentName: 'PipMandi',
    chunk: () => import(
      /* webpackChunkName: "pipMandi" */
      './pages/pip/PipMandi'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/pip/PipMandi.js')).PipMandi
        : currentRouteName === 'pipMandi'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PipMandi })));
    },
    path: '/:context?/p/mandi/:slug?/:itemId',
    channel: null
  },
  pcp: {
    name: 'pcp',
    componentName: 'Pcp',
    chunk: () => import(
      /* webpackChunkName: "pcp" */
      './pages/pcp/Pcp'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/pcp/Pcp.js')).Pcp
        : currentRouteName === 'pcp'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Pcp })));
    },
    path: [':context?/custom-blinds/Configurator',
      ':context?/custom-blinds/configurator/EditByGuid',
      ':context?/custom-blinds/configurator/CreateMandi',
      ':context?/custom-blinds/configurator/CreateEstimate',
      ':context?/custom-blinds/configurator/EditMandi',
      ':context?/custom-blinds/configurator/EditEstimate',
      ':context?/custom-blinds/configurator/Copy',
      ':context?/custom-blinds/configurator/Draft',
    ],
    channel: null
  }
});
